import {
    Box,
    IconButton,
    Tooltip
  } from "@mui/material";
  import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
  import ChevronRightIcon from "@mui/icons-material/ChevronRight";
  import SidePanel from "./SidePanel";
  
//   export default function CollapsibleSidePanel({ open, setOpen }) {
//     return (
//       <Box
//         sx={{
//           width: open ? 300 : 48,
//           transition: "width 0.25s ease",
//           borderRight: "1px solid #ddd",
//           overflow: "visible",
//           position: "relative"
//         }}
//       >
//         {/* Toggle Button */}
//         <Tooltip title={open ? "Collapse" : "Expand"}>
//           <IconButton
//             size="small"
//             onClick={() => setOpen(!open)}
//             sx={{
//               position: "absolute",
//               top: 8,
//               right: 8,
//               zIndex: 10
//             }}
//           >
//             {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
//           </IconButton>
//         </Tooltip>
  
//         {/* Content visible only when open */}
//         {open && <SidePanel />}
//       </Box>
//     );
//   }


export default function CollapsibleSidePanel({ open, setOpen }) {
  return (
    <Box sx={{ display: "flex", position: "relative" }}>
     
      {/* Side panel */}
      <Box
        sx={{
          width: open ? 280 : 48,
          height: window.innerHeight - 160, // Adjust height as needed
          transition: "width 0.25s ease",
          borderRight: "1px solid #ddd",
          overflow: "hidden",
          overflowY: "scroll",
        }}
      >
        {open && <SidePanel />}
      </Box>

      {/* Toggle button (always visible) */}
      <Tooltip title={open ? "Collapse" : "Expand"}>
        <IconButton
          size="small"
          onClick={() => setOpen(!open)}
          sx={{
            position: "absolute",
            top: 8,
            left: open ? 295 : 8, // :point_left: smart positioning
            zIndex: 20,
            backgroundColor: "#fff",
            border: "1px solid #ddd",
          }}
        >
          {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </IconButton>
      </Tooltip>
    </Box>
  );
}